import categories from 'stores/categories'
import documentTypes from 'stores/document-types'
import productTemplates from 'stores/product-templates'
import products from 'stores/products'
import providers from 'stores/providers'
import signatoryTypes from 'stores/signatory-types'
import signatureParameters from 'stores/signature-parameters'
import tags from 'stores/tags'
import templateAttachments from 'stores/template-attachments'
import templates from 'stores/templates'
import { DefineGlobalPiniaStore } from '@bildvitta/store-adapter'
import { boot } from 'quasar/wrappers'
import { hubStore } from 'hub/pinia'

export default boot(({ app }) => {
  app.use(DefineGlobalPiniaStore, {
    stores: {
      categories,
      documentTypes,
      hub: hubStore,
      productTemplates,
      products,
      providers,
      signatoryTypes,
      signatureParameters,
      tags,
      templateAttachments,
      templates
    }
  })
})
